module.exports = __webpack_public_path__ + "media/02.6b3fe2b0.wav";